import { RoomType } from 'src/models/Room'
import { ApiClient } from './client'
import {
  deleteCompanyMessageRoomTagMapping,
  POST_COMPANY_MESSAGE_ROOM_TAG_MAPPINGS,
} from './endpoints'
import { ApiResponse } from './types'

type CreateTagMappingRequest = {
  company_message_room_tag_mapping: {
    company_message_room_tag_id: number
    room_id: number
    room_type: RoomType
  }
}
type CreateTagMappingResponse = {
  id: number
}
export const createTagMapping = async (
  request: CreateTagMappingRequest['company_message_room_tag_mapping'],
): Promise<ApiResponse<CreateTagMappingResponse>> => {
  const body: CreateTagMappingRequest = {
    company_message_room_tag_mapping: {
      ...request,
    },
  }
  const res = await ApiClient.post<CreateTagMappingResponse>(
    POST_COMPANY_MESSAGE_ROOM_TAG_MAPPINGS,
    body,
  )
  if (res.error) return res
  return res
}

export const deleteTagMapping = async (id: number) => {
  const res = await ApiClient.delete(deleteCompanyMessageRoomTagMapping(id))
  if (res.error) return res
  return res.data
}
